/**
 * Mesaj grubu boşluğu (message group spacing) — kaynak-referans
 * `accessibility/state/MessageGroupSpacing` 1-1 saf (pure) portu.
 *
 * Mesaj listesinde ardışık mesaj grupları arasındaki dikey boşluğu hesaplayan
 * saf yardımcılar. Backend/store/endpoint bağımlılığı YOKTUR — yalnızca değer
 * dönüştürür. "Comfy" (rahat) ve "compact" (sıkışık) görüntü modlarının her biri
 * kendi bağımsız varsayılan boşluğuna sahiptir.
 */

/** Comfy (rahat) modun varsayılan grup boşluğu (px). */
export const COMFY_MESSAGE_GROUP_SPACING_DEFAULT = 16;
/** Compact (sıkışık) modun varsayılan grup boşluğu (px). */
export const COMPACT_MESSAGE_GROUP_SPACING_DEFAULT = 0;

/** Her iki görüntü modu için saklanan grup boşluğu ayarları. */
export interface MessageGroupSpacingSettings {
  messageGroupSpacing: number;
  compactMessageGroupSpacing: number;
}

/** Kısmi güncelleme yaması (yalnızca değişen mod alanını taşır). */
export interface MessageGroupSpacingPatch {
  messageGroupSpacing?: number;
  compactMessageGroupSpacing?: number;
}

/**
 * Aktif görüntü moduna göre varsayılan grup boşluğunu döndürür.
 *
 * @param messageDisplayCompact Compact mod aktif mi.
 */
export function getDefaultMessageGroupSpacing(messageDisplayCompact: boolean): number {
  return messageDisplayCompact ? COMPACT_MESSAGE_GROUP_SPACING_DEFAULT : COMFY_MESSAGE_GROUP_SPACING_DEFAULT;
}

/**
 * Ayarlardan, aktif görüntü moduna karşılık gelen grup boşluğunu okur.
 */
export function getMessageGroupSpacingForDisplayMode(
  settings: MessageGroupSpacingSettings,
  messageDisplayCompact: boolean,
): number {
  return messageDisplayCompact ? settings.compactMessageGroupSpacing : settings.messageGroupSpacing;
}

/**
 * Yalnızca aktif görüntü modunun alanını güncelleyen bir yama üretir.
 */
export function getMessageGroupSpacingPatch(
  messageDisplayCompact: boolean,
  messageGroupSpacing: number,
): MessageGroupSpacingPatch {
  return messageDisplayCompact ? {compactMessageGroupSpacing: messageGroupSpacing} : {messageGroupSpacing};
}

/**
 * Tek değerli eski (legacy) grup boşluğu ayarını, moda göre ayrık ayarlara taşır.
 *
 * Eski değer aktif modun varsayılanıysa, her iki mod da kendi varsayılanına
 * sıfırlanır; aksi halde özel değer her iki mod için paylaşılan değer olur.
 */
export function migrateLegacyMessageGroupSpacing(
  legacyMessageGroupSpacing: number,
  messageDisplayCompact: boolean,
): MessageGroupSpacingSettings {
  const currentModeDefault = getDefaultMessageGroupSpacing(messageDisplayCompact);
  if (legacyMessageGroupSpacing === currentModeDefault) {
    return {
      messageGroupSpacing: COMFY_MESSAGE_GROUP_SPACING_DEFAULT,
      compactMessageGroupSpacing: COMPACT_MESSAGE_GROUP_SPACING_DEFAULT,
    };
  }
  return {
    messageGroupSpacing: legacyMessageGroupSpacing,
    compactMessageGroupSpacing: legacyMessageGroupSpacing,
  };
}
